import { Component, OnInit } from '@angular/core';
import { MatBottomSheet} from '@angular/material/bottom-sheet';
import { EnquiryComponent } from '../enquiry/enquiry.component';
import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { LocationMappingService } from '../services/location-mapping.service';



@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css', '../app.component.css']
})
export class AboutComponent implements OnInit {
  public philosophy = {
    p1: `We believe that training in the latest computer technologies
   combined with life-long learning are the essential ingredients for building a successful
   career in the IT Industry. Students are trained in a multi-cultural atmosphere providing
   student-centered interactive learning which is centered on today’s computerized business
   environment.`,
   p2: `NICT emphasis is given to the maximum extent on the projects by maximum practical
   learning through simulated projects designed to the needs of the industry.
   “Practice makes a man perfect”. A belief that is unanimously shared at NICT.
   This is quite evident from the fact that the Diploma courses offer more computer
   time than theory, a popular concept in modern education.`
  };


  public facility = `Our labs are equipped with modern systems highlighting a multi
    environment, multi user networked to all the terminals. The system can run different
    operating system MSDOS, Windows, Unix & Linux simultaneously, with a backup of electricity
    under UPS and also equipped with the generator to assure an uninterrupted power supply
    with high speed Internet connections.`;

  public hop = `Classes are scheduled for Mon, Wed, Friday;
  or on Tuesday, Thurs, Saturday; Centers are open Monday to Saturday 7 a.m. to 9 p.m.
  & on Sundays 9 a.m. to 1 p.m. Special Fast Track and Weekend batches are also available.`;

  public overview = {
    p1: `NICT provides high quality computer education at a very high standard at a very low cost.
     NICT’s mission is to create a pool of high quality software professionals who will meet the
      demanding needs of multinational organizations for tomorrow’s challenges.`,

    p2: `Training methods have been maximized with “learning” rather than
     “teaching” through well equipped lab ONE-TO-ONE ratio (ONE COMPUTER FOR ONE STUDENT).
      With structured combination of theoretical and practical sessions, reinforced with colour
       Pentium computers in every class room for live demonstrations.`
  };

  constructor(
    private bottomSheet: MatBottomSheet,
    private titleService: Title,
    private metaService: Meta,
    private route: ActivatedRoute,
    private locationMappingService: LocationMappingService
  ) { }
  
  ngOnInit() {
    this.titleService.setTitle('About NICT Computer Education | Best Computer Training Institute');
    this.metaService.updateTag({
      name: 'description',
      content: 'Learn about NICT Computer Education’s mission, teaching philosophy, facilities, and training standards. Empowering future IT professionals since 1995.'
    });

    // Optional: Open Graph tags
    this.metaService.updateTag({ property: 'og:title', content: 'About NICT Computer Education' });
    this.metaService.updateTag({ property: 'og:description', content: 'Learn about NICT’s teaching philosophy, facilities, and student-focused IT training.' });
}


  openBottomSheet(): void {
    // Get location from URL if available
    const locationFromUrl = this.getLocationFromUrl();
    
    this.bottomSheet.open(EnquiryComponent,{
      data:{
        source : "about page",
        location: locationFromUrl
      }
    });
  }

  getLocationFromUrl(): string | null {
    const locationParam = this.route.snapshot.paramMap.get('location');
    if (locationParam) {
      // Store the slug and get location
      return this.locationMappingService.getLocationAndStore(locationParam);
    }
    // If no location in URL, check localStorage
    return this.locationMappingService.getStoredLocation();
  }
}









